const SearchResults = ({ searchResults }) => {
  return (
    <ul>
      {searchResults.length > 0 ? (
        searchResults.map((result, index) => (
          <li key={index}>
            <div>
              <a 
                target="_blank" 
                rel="noopener noreferrer" 
                href={`https://www.normattiva.it${result.metadata.link}`}
              >
                {result.metadata.title}
              </a>
            </div>
            <div>
              <span>{result.metadata.sentence}</span>
            </div>
          </li>
        ))
      ) : (
        <li>No results found.</li>
      )}
    </ul>
  );
};

export default SearchResults;